<template>
    <div>
        <Modal v-model="isShowModal" :title="title" @on-cancel="hide('formValidate')" :mask-closable="false"
               width="800">

            <Divider orientation="left">用户信息</Divider>
            <Row :gutter="16">
                <Col span="8">
                    <div>用户称呼：{{ feedbackInfo.userName ? feedbackInfo.userName : '-' }}</div>
                </Col>
                <Col span="8">
                    <div>用户手机：{{ feedbackInfo.phone ? feedbackInfo.phone : '-' }}</div>
                </Col>
                <Col span="8">
                    <div>反馈类型：{{ feedbackInfo.type == 1 ? '意见反馈' : '投诉反馈' }}</div>
                </Col>
            </Row>
            <Divider orientation="left">反馈内容</Divider>
            <Row :gutter="16">
                <Col span="16">
                    <div>{{ feedbackInfo.content ? feedbackInfo.content : '-' }}</div>
                </Col>
            </Row>
            <Divider orientation="left">反馈图片</Divider>
            <div class="jw-images-row" v-if="feedbackInfo.feedbackImg.length > 0">
                <img class="jw-image" v-for="(item,index) in feedbackInfo.feedbackImg" :src="item"
                     @click="showImg(index)">
            </div>

            <viewer :images="images" class="viewer" ref="viewer" @inited="inited" v-show="showImage">
                <template scope="scope">
                    <img v-for="src in scope.images" :src="src" :key="src">
                    {{ scope.options }}
                </template>
            </viewer>

            <!-- 重写对话框底部按钮 -->
            <div slot="footer">
                <Button @click="hide('formValidate')">取消</Button>
                <Button v-if="type != 1" type="primary" @click="hide('formValidate')" :loading="loadingBtn">
                    <span v-if="!loadingBtn">确定</span>
                    <span v-else>请稍候...</span>
                </Button>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isShowModal: false,
            loadingBtn: false,
            title: '查看信息',
            type: 0,
            images: [],
            feedbackInfo: {
                feedbackImg: []
            },
            showImage: false
        }
    },
    methods: {
        // 显示模态框
        show(type, row) {
            this.isShowModal = true;
            this.type = type;
            /**
             * type判断
             * 1.查看 2.新增 3.编辑
             */
            switch (type) {
                case 1:
                    this.title = '查看投诉及意见';
                    this.findFeedbackById(row);
                    break;
                case 2:
                    this.title = '新增投诉及意见';
                    break;
                case 3:
                    this.title = '编辑投诉及意见';
                    this.findFeedbackById(row);
                    break;
                default:
                    this.$Notice.error({
                        title: '投诉及意见管理',
                        desc: '查看，新增，编辑模态框报错',
                        duration: 0
                    });
                    break
            }
        },
        // 查询投诉及意见详情
        findFeedbackById(row) {
            this.$Spin.show();
            this.axios.post('/feedback/findFeedbackById', {
                feedbackId: row.feedbackId
            }).then(res => {
                console.log(res);
                setTimeout(() => {
                    this.$Spin.hide();
                }, 300);
                if (res.status == 200) {
                    this.feedbackInfo = res.data;
                    if (res.data.feedbackImg) {
                      this.feedbackInfo.feedbackImg = res.data.feedbackImg.split(',');
                      this.images = this.feedbackInfo.feedbackImg;
                    }
                }
                if (res.status == 500) {
                    this.$Notice.error({
                        title: '服务器内部错误',
                        desc: '查看投诉及意见接口报错',
                        duration: 0
                    });
                }
            })
        },
        inited(viewer) {
            this.$viewer = viewer
        },
        showImg(index) {
            console.log(index)
            this.$viewer.show();
        },
        // 关闭模态框
        hide(name) {
            this.isShowModal = false;
            // this.$refs[name].resetFields();
        }
    },
}
</script>

<style scoped>
.jw-images-row {
    display: flex;
    align-items: center;
}

.jw-image {
    width: 150px;
    height: 150px;
    margin-right: 10px;
}
</style>
